import { render, staticRenderFns } from "./IgE.vue?vue&type=template&id=3ccf1c58&scoped=true&"
import script from "./IgE.vue?vue&type=script&lang=js&"
export * from "./IgE.vue?vue&type=script&lang=js&"
import style0 from "./IgE.vue?vue&type=style&index=0&id=3ccf1c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf1c58",
  null
  
)

export default component.exports